import React from 'react'
import about from '../../Assets/about.png'
export const About = () => {
  return (
        <div className='flex flex-col-reverse md:flex-row sm:gap-2 md:gap-8 p-8 bg-gradient-to-r from-indigo-900 to-sky-400 md:h-screen' id='about'>

            <div className=' sm:w-3/5 md:w-1/2 text-white flex flex-col justify-center md:px-8 text-wrap'> 
              <div className='w-max inline-block'>
                <h1 className=' font-bold text-xl md:text-4xl lg:text-5xl mb-1'>About me</h1>
                <hr  className='  md:h-1 bg-white border-0 rounded-md md:mb-6'/>
              </div>
              <p className='text-xs  md:text-sm lg:text-xl    md:leading-6 lg:leading-8'>
                I’m a passionate and dedicated Computer Science student with a strong foundation in Html,CSS, JavaScript, React.js. I enjoy building user-friendly web applications and learning new technologies.Currently pursuing my B.Tech from SIET, I’ve completed training in Reactjs, where I worked on hands-on projects that enhanced my understanding of real-world development.
                I'm looking for opportunities to apply my skills in a professional setting and grow as a developer while contributing to impactful projects.
              </p>
            
            </div> 

            <div className=' md:w-1/2 md:p-12 lg:p-24 flex justify-center object-contain'>  <img src={about} alt="" className='  rounded-3xl size-36 md:size-full' /></div>
        </div> 
  )
}
